module.exports = __webpack_public_path__ + "img/Connect-to-multiple-countries.694f25b2.png";